// extracted by mini-css-extract-plugin
export default {"hidden_button":"styled_hidden_button__CtFVL"};